var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.8916,
    r: 11,
    stroke: "#25368D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7362 7.15521C8.38473 6.80374 7.81487 6.80374 7.46341 7.15521L5.06341 9.55521C4.71194 9.90667 4.71194 10.4765 5.06341 10.828C5.41487 11.1794 5.98473 11.1794 6.3362 10.828L7.1998 9.96439V17.3916C7.1998 17.8886 7.60275 18.2916 8.0998 18.2916C8.59685 18.2916 8.9998 17.8886 8.9998 17.3916V9.96439L9.86344 10.828C10.2149 11.1794 10.7847 11.1794 11.1362 10.828C11.4876 10.4765 11.4876 9.90667 11.1362 9.55521L8.7362 7.15521Z",
    fill: "#25368D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1998 7.7916C16.1998 7.29455 15.7968 6.8916 15.2998 6.8916C14.8028 6.8916 14.3998 7.29455 14.3998 7.7916V15.2188L13.5362 14.3552C13.1847 14.0038 12.6149 14.0038 12.2634 14.3552C11.912 14.7067 11.912 15.2765 12.2634 15.628L14.6634 18.028C15.0149 18.3794 15.5847 18.3794 15.9362 18.028L18.3362 15.628C18.6876 15.2765 18.6876 14.7067 18.3362 14.3552C17.9847 14.0038 17.4149 14.0038 17.0634 14.3552L16.1998 15.2188V7.7916Z",
    fill: "#25368D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompare);
export default __webpack_public_path__ + "static/media/icon-compare.44220f0fac28d3d66aa8abc76e37cc55.svg";
export { ForwardRef as ReactComponent };